export function isOfflineFastFail( error: unknown ): boolean
{
  return error instanceof Error && error.name === "NetworkError" && error.message === "offline";
}

export function isConfigMissing( error: unknown ): boolean
{
  return error instanceof Error && error.name === "ApiError" && ( error as { status?: number } ).status === 404;
}

export function isNetworkishError( error: unknown ): boolean
{
  if ( typeof navigator !== "undefined" && navigator.onLine === false ) return true;
  if ( error instanceof Error && error.name === "NetworkError" ) return true;
  const message = error instanceof Error ? `${error.name} ${error.message}` : String( error );
  return /failed to fetch|load failed|networkerror|network error|net::|timed? ?out|aborted|offline/i.test( message );
}

export function isAmbiguousNetworkFailure( error: unknown ): boolean
{
  const message = error instanceof Error ? `${error.name} ${error.message}` : String( error );
  return /abort|timed? ?out/i.test( message );
}
